import React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { Card, CardContent, Tab, Tabs } from "@mui/material";
import TeamMembersTable from "pages/dashboard/settings/property/stages/members";
import { InterestListPageTitle, InterestListPageTitleVariables } from "types/gql-types";
import { AdminHeading } from "../shared/admin-form";
import { createTabPanel } from "../tab-panel";
import InterestListFilters from "./filters";
import InterestListDetails from "./update-container";
import InterestListDisclaimers from "./unit-disclaimers";
import { INTEREST_LIST_PAGE_TITLE } from "./page-queries";

enum TabsIndex {
  Details = 0,
  Filters = 1,
  Disclaimers = 2,
  TeamMembers = 3,
}

const TabPanel = createTabPanel(
  {
    details: TabsIndex.Details,
    filters: TabsIndex.Filters,
    disclaimers: TabsIndex.Disclaimers,
    team: TabsIndex.TeamMembers,
  },
  "interest-list-tab",
);

const InterestListTabPanels: React.FC<{ interestListId: string; tabIndex: TabsIndex }> = ({
  interestListId,
  tabIndex,
}) => (
  <Card>
    <CardContent>
      <TabPanel tabIndex={tabIndex} id="details">
        <InterestListDetails interestListId={interestListId} />
      </TabPanel>
      <TabPanel tabIndex={tabIndex} id="filters">
        <InterestListFilters interestListId={interestListId} />
      </TabPanel>
      <TabPanel tabIndex={tabIndex} id="disclaimers">
        <InterestListDisclaimers interestListId={interestListId} />
      </TabPanel>
      <TabPanel tabIndex={tabIndex} id="team">
        <TeamMembersTable listId={interestListId} isAdmin path="" />
      </TabPanel>
    </CardContent>
  </Card>
);

const UpdateInterestListPage: React.FC = () => {
  const { id: interestListId } = useParams<{ id: string }>();
  const [tabIndex, setTabIndex] = React.useState<TabsIndex>(0);
  const { data: titleData, loading: titleLoading } = useQuery<
  InterestListPageTitle,
  InterestListPageTitleVariables
  >(INTEREST_LIST_PAGE_TITLE, {
    variables: { id: interestListId ?? "" },
    skip: !interestListId,
    fetchPolicy: "cache-and-network",
  });

  if (!interestListId) return <div>Invalid URL</div>;

  const listName = titleData?.interestList?.name;
  const titleContent = titleLoading && !listName ? "…" : listName || "Interest list";

  return (
    <>
      <AdminHeading component="h1">{titleContent}</AdminHeading>
      <Tabs
        value={tabIndex}
        onChange={(_: React.SyntheticEvent, index: TabsIndex) => setTabIndex(index)}
      >
        <Tab label="Details" />
        <Tab label="Filters" />
        <Tab label="Unit Disclaimers" />
        <Tab label="Team Members" />
      </Tabs>
      <InterestListTabPanels interestListId={interestListId} tabIndex={tabIndex} />
    </>
  );
};

export default UpdateInterestListPage;
